import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material'
import React from 'react'

const ReusableDialog = ({isOpen,content,buttonText,setOpenFunction,handleDialogConfirm}) => {
  return (
    <Dialog
    open={isOpen}
    onClose={()=>setOpenFunction(false)}
    >
        <DialogContent>
            <DialogContentText>
                {content}
            </DialogContentText>
            <DialogActions>
            <Button
                variant='contained'
                color='error'
                onClick={()=>setOpenFunction(false)}
                sx={{color:'white'}}
                >
                    Close
                </Button>
                <Button
                variant='contained'
                color='success'
                onClick={handleDialogConfirm}
                sx={{color:'white'}}
                >
                    {buttonText}
                </Button>
            </DialogActions>
        </DialogContent>
    </Dialog>
  )
}

export default ReusableDialog